import { useEffect, useState, type ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getPasswordChangeStatus } from "../services/auth";

/**
 * Route guard that enforces mandatory password change before accessing
 * protected routes. Calls the backend on mount to check whether the
 * user's account is locked until they change their password.
 */

interface GuardProps {
 children: ReactElement;
}

export default function RequirePasswordChangeClear({ children }: GuardProps) {
 const location = useLocation();
 const [status, setStatus] = useState<"loading" | "locked" | "clear">("loading",
 );

 useEffect(() => {
 let cancelled = false;
 getPasswordChangeStatus()
 .then((res) => {
 if (!cancelled) {
 setStatus(res.passwordChangeRequired ?"locked":"clear");
 }
 })
 .catch(() => {
 // On error (network failure, etc.) let the user through
 if (!cancelled) setStatus("clear");
 });
 return () => {
 cancelled = true;
 };
 }, []);

 if (status ==="loading") {
 return <p>Checking session…</p>;
 }

 if (status ==="locked"&& location.pathname !=="/change-password") {
 return <Navigate to="/change-password"replace />;
 }

 return children;
}
